export const APP_TASK_TABLE_CONFIG = (intl) => [
  {
    key: 'tipologia_nombre',
    label: intl.formatMessage({
      id: 'pages.application.detail.history.tableFields.tipo',
    }),
    align: 'left',
  },
  {
    key: 'documento_campo',
    label: intl.formatMessage({
      id: 'pages.application.detail.history.tableFields.documento_campo',
    }),
    align: 'left',
  },
  {
    key: 'estado_nombre',
    label: intl.formatMessage({ id: 'pages.application.detail.history.tableFields.estado' }),
    align: 'left',
  },
  {
    key: 'dg_ts_insert_formatted',
    label: intl.formatMessage({ id: 'pages.application.detail.history.tableFields.fecha' }),
    align: 'left',
  },
  {
    key: 'observaciones',
    label: intl.formatMessage({ id: 'pages.application.detail.history.tableFields.observaciones' }),
    align: 'left',
  },
]
